<template>

  <v-data-table
    dense
    :headers='headers'
    :items='entries'
    item-key='date'
    class='grey lighten-4'
    :expanded.sync='expanded'
    show-expand
    no-data-text='No Data - Please Generate a Report'
    hide-default-footer
    :hide-default-header='!entries.length'
    disable-pagination
    disable-sort
  >
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan='headers.length' class='pr-0 py-1 pl-12'>
        <worked-ons-table
          :entry='item'
          @openEntry='openEntry'
          @addEntry='addEntry'
          @deleteEntry='deleteEntry'
        ></worked-ons-table>
      </td>
    </template>

    <template v-slot:item.alerts='{ item }'>
      <template v-if='item.kms_notes'>
        <span class='caption' style='letter-spacing: -0.5px !important;'>{{'kms: ' + item.kms_notes}}</span>
      </template>

      <template v-if='detailMissing(item)'>
        <span class='ml-2 purple--text'>Detail missing</span>
        <v-icon right small color='purple'>mdi-alert</v-icon>
      </template>

      <template v-if='item.duplicateDate'>
        <span class='ml-2 red--text'>Duplicate Entry!</span>
        <v-icon right small color='red'>mdi-alert-octagon</v-icon>
      </template>
    </template>

    <template v-slot:item.hours_worked='{ item }'>
      <span v-if='!item.employee_obj' style='margin-right: 2px !important;' class='orange--text font-weight-bold'>-</span>
      <span v-else>{{ item.hours_worked ? item.hours_worked.toFixed(2) : item.hours_worked }}</span>
    </template>

    <template v-slot:item.date="{ item }">
      {{ item.date | longDateWithDayAtEnd }}
    </template>
  </v-data-table>
  
</template>

<script>
import WorkedOnsTable from './PayrollWorkedOnsTable'

export default {
  name: 'payroll-entry-table',
  props: {
    entries: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    expanded: [],
    headers: [
      { text: 'Day', value: 'date', class:'subtitle-2', align: 'start', width: '250' },
      { text: '', value: 'alerts', class:'overline', align: 'end' },
      { text: 'Hrs/day', value: 'hours_worked', class:'subtitle-2', align: 'end', width: '100' },
      { text: 'Kms/day', value: 'kms', class:'subtitle-2', align: 'end', width: '100' },
      { text:'', value: 'data-table-expand' }
    ]
  }),
  computed: {

  },
  methods: {
    openEntry (entry) {
      this.$emit("openEntry", entry)
    },
    detailMissing (entry) {
      return entry.hours_left_to_assign ? true : false
    },
    addEntry (entry) {
      this.$emit("addEntry", entry)
    },
    deleteEntry (entry) {
      this.$emit("deleteEntry", entry)
    }
  },
  components: {
    'worked-ons-table': WorkedOnsTable
  }
}

</script>